// extracted by mini-css-extract-plugin
export default {"teamWrapper":"Replayer_teamWrapper__BKXfN","teamContent":"Replayer_teamContent__7R5hg","notesWrapper":"Replayer_notesWrapper__Nyxbi"};